import { render, staticRenderFns } from "./myNote.vue?vue&type=template&id=097b7afc&scoped=true"
import script from "./myNote.vue?vue&type=script&lang=js"
export * from "./myNote.vue?vue&type=script&lang=js"
import style0 from "./myNote.vue?vue&type=style&index=0&id=097b7afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b7afc",
  null
  
)

export default component.exports